---
title: "Analysen lesen"
slug: viewing-analytics
description: "Überblick über das Analytics-Dashboard: Wirkung, Aktivitätsbericht, Bestandsgesundheit und Standortleistung lesen."
keywords:
  - Analysen
  - Dashboard
  - Wirkung
  - Aktivitätsbericht
  - Bestandsgesundheit
  - Standortleistung
  - CO2
---

## Voraussetzungen

- Rolle: Manager oder Company Admin
- Mindestens einige Scan-Ereignisse müssen im ausgewählten Zeitraum vorliegen

## Schritt für Schritt

1. Navigieren Sie im oberen Menü zu **Analytik**.
2. Wählen Sie oben rechts den gewünschten Zeitraum aus: z. B. **Letzte 7 Tage**, **Letzte 30 Tage**, **Letzter Monat**, **Letzte 90 Tage**, **Seit Jahresbeginn** oder **Eigener Zeitraum**.
3. Lesen Sie den Abschnitt **Wirkung**: Hier sehen Sie die Anzahl der Sendungen, das CO₂ eingespart und den vermiedenen Abfall für den gewählten Zeitraum.
4. Prüfen Sie den **Aktivitätsbericht**: Das monatliche Scan-Volumen-Diagramm zeigt, wie viele Sendungen je Monat erfasst wurden.
5. Öffnen Sie **Bestandsgesundheit**: Hier sehen Sie die Gesamtanzahl Ihrer Boxen aufgeteilt nach Status (Aktiv, Defekt, Kurz vor EOL, End of Life) sowie die Defektrate nach Standort.
6. Prüfen Sie die **Standortleistung**: Die Tabelle listet alle Standorte mit Scan-Volumen, Durchschnittlicher Verweildauer, Defektrate und Bestandsungleichgewicht auf. Ein Badge **Ungleichgewicht** oder **Starkes Ungleichgewicht** weist darauf hin, dass mehr Pakete in eine Richtung fließen als zurück.

## Wenn es schiefgeht

- **"Keine Daten für den ausgewählten Zeitraum"** — In diesem Zeitraum wurden keine Scans erfasst. Wählen Sie einen größeren Zeitraum oder prüfen Sie, ob Scans in den letzten Tagen stattgefunden haben.
- **"Keine Standortdaten für den ausgewählten Zeitraum"** — Für den gewählten Zeitraum wurden für einzelne Standorte keine Scans erfasst.
- **Zahlen unterscheiden sich von Erwartungen** — Prüfen Sie, ob der ausgewählte Zeitraum korrekt ist. Daten werden auf Basis abgeschlossener Scan-Ereignisse berechnet.
- Kontaktieren Sie uns: support@heycircle.com oder nutzen Sie die Feedback-Schaltfläche unten rechts auf dem Bildschirm.

## Verwandte Artikel

- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Pakete senden](/app/help?article=sending-a-package)
- [Ersteinrichtung](/app/help?article=initial-setup)
